export const LOAD_COMMISSIONS_ATTEMPT =
  'admin/mercadoPago/LOAD_COMMISSIONS_ATTEMPT'
export const LOAD_COMMISSIONS_SUCCESS =
  'admin/mercadoPago/LOAD_COMMISSIONS_SUCCESS'
export const LOAD_COMMISSIONS_FAILURE =
  'admin/mercadoPago/LOAD_COMMISSIONS_FAILURE'

export const RESET = 'admin/mercadoPago/RESET'
